__turbopack_context__.v({
  "container": "aJ75Wa_container",
  "iconWrapper": "aJ75Wa_iconWrapper",
  "link": "aJ75Wa_link",
  "linkTextSpan": "aJ75Wa_linkTextSpan",
  "linkTextWrapper": "aJ75Wa_linkTextWrapper",
  "linksWrapper": "aJ75Wa_linksWrapper",
});
